(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5472],{

/***/ 711:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]",
      function () {
        return __webpack_require__(1663);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Hotel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/FormBookNowV2.tsx + 1 modules
var FormBookNowV2 = __webpack_require__(7423);
// EXTERNAL MODULE: ./src/components/HeroV2.tsx
var HeroV2 = __webpack_require__(2699);
// EXTERNAL MODULE: ./src/components/SectionDining.jsx
var SectionDining = __webpack_require__(9646);
// EXTERNAL MODULE: ./src/components/SectionEvent.tsx + 1 modules
var SectionEvent = __webpack_require__(3934);
// EXTERNAL MODULE: ./src/components/SectionGallery.tsx
var SectionGallery = __webpack_require__(2493);
// EXTERNAL MODULE: ./src/components/SectionHotel.jsx
var SectionHotel = __webpack_require__(9938);
// EXTERNAL MODULE: ./node_modules/interweave/esm/index.js + 1 modules
var esm = __webpack_require__(9996);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
;// CONCATENATED MODULE: ./src/components/SectionHotelIntro.jsx








function SectionHotelIntro(param) {
    var _facilities = param.facilities, facilities = _facilities === void 0 ? [] : _facilities, _hotelName = param.hotelName, hotelName = _hotelName === void 0 ? "" : _hotelName, _hotelLoc = param.hotelLoc, hotelLoc = _hotelLoc === void 0 ? "" : _hotelLoc, _hotelDesc = param.hotelDesc, hotelDesc = _hotelDesc === void 0 ? "" : _hotelDesc, color = param.color, _slug = param.slug, slug = _slug === void 0 ? "" : _slug;
    var locale = (0,router.useRouter)().locale;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                w: "100%",
                mb: 10,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        as: "h1",
                        size: "lg",
                        fontWeight: 300,
                        letterSpacing: "widest",
                        textAlign: "center",
                        color: color ? color : "gray.800",
                        mb: 4,
                        children: hotelName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        as: "h2",
                        size: "sm",
                        fontWeight: 300,
                        letterSpacing: "wide",
                        textAlign: "center",
                        color: "blackAlpha.700",
                        mb: 6,
                        children: hotelLoc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                            w: [
                                "90%",
                                "80%",
                                "50%"
                            ],
                            textAlign: "center",
                            color: "blackAlpha.700",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Markup */.Lu, {
                                content: (ref = hotelDesc === null || hotelDesc === void 0 ? void 0 : hotelDesc.replace(/\\n/g, "<br>")) !== null && ref !== void 0 ? ref : ""
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                gap: 3,
                flexWrap: {
                    base: "wrap",
                    md: "nowrap"
                },
                children: facilities.map(function(f, i) {
                    var icon, text;
                    if (f.includes("Concierge")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHotel */.X2f, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp = f.split("/");
                            locale == "id" ? text = temp[1] : text = temp[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Front Desk")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHotel */.X2f, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp1 = f.split("/");
                            locale == "id" ? text = temp1[1] : text = temp1[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Wi-Fi")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaWifi */._0, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp2 = f.split("/");
                            locale == "id" ? text = temp2[1] : text = temp2[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Swimming Pool")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSwimmingPool */.ein, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp3 = f.split("/");
                            locale == "id" ? text = temp3[1] : text = temp3[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Restaurant")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaUtensils */.yQ2, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp4 = f.split("/");
                            locale == "id" ? text = temp4[1] : text = temp4[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Massage")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaHandSparkles */.sFF, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp5 = f.split("/");
                            locale == "id" ? text = temp5[1] : text = temp5[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Fitness Center")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaDumbbell */.ee, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp6 = f.split("/");
                            locale == "id" ? text = temp6[1] : text = temp6[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Kids Playground")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChild */.OXn, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp7 = f.split("/");
                            locale == "id" ? text = temp7[1] : text = temp7[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Meeting Room")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaUsers */.I$, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp8 = f.split("/");
                            locale == "id" ? text = temp8[1] : text = temp8[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Ballroom")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaUniversity */.Q7H, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp9 = f.split("/");
                            locale == "id" ? text = temp9[1] : text = temp9[0];
                        } else {
                            text = f;
                        }
                    }
                    if (f.includes("Laundry")) {
                        icon = /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTshirt */.rJ4, {
                            color: "grey",
                            size: 30
                        });
                        if (f.includes("/")) {
                            var temp10 = f.split("/");
                            locale == "id" ? text = temp10[1] : text = temp10[0];
                        } else {
                            text = f;
                        }
                    }
                    if (!text) return null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                w: 100,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                                    flexDir: "column",
                                    justify: "space-between",
                                    h: "100%",
                                    w: "100%",
                                    gap: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                            children: icon
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Tooltip */.ua7, {
                                            label: text,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                                className: "max-text-1-line",
                                                textAlign: "center",
                                                textTransform: "capitalize",
                                                fontSize: "xs",
                                                overflow: "hidden",
                                                color: "blackAlpha.700",
                                                children: text
                                            })
                                        })
                                    ]
                                })
                            }),
                            i + 1 < facilities.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
                                h: "80px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                                    orientation: "vertical",
                                    opacity: 1,
                                    my: 3,
                                    borderWidth: 0.5,
                                    py: 0.1,
                                    borderColor: "blackAlpha.100",
                                    bg: "blackAlpha.100"
                                })
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/SectionSpecialOffer.jsx
var SectionSpecialOffer = __webpack_require__(3361);
// EXTERNAL MODULE: ./src/containers/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(9536);
// EXTERNAL MODULE: ./src/layout/FooterHotel.jsx
var FooterHotel = __webpack_require__(8078);
// EXTERNAL MODULE: ./src/layout/HeaderV3.tsx + 4 modules
var HeaderV3 = __webpack_require__(4850);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
;// CONCATENATED MODULE: ./src/pages/[hid]/index.tsx

















var __N_SSG = true;
function Hotel(param) {
    var header = param.header, hotelBrands = param.hotelBrands, hero = param.hero, hotelHome = param.hotelHome;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(0), headerHeight1 = ref[0], setHeaderHeight = ref[1];
    var color_primary = hotelHome.color_primary, facilities = hotelHome.facilities, home_subheadline = hotelHome.home_subheadline, color_secondary = hotelHome.color_secondary, hotel_location = hotelHome.hotel_location, id = hotelHome.id, logo_light = hotelHome.logo_light, name = hotelHome.name, brand = hotelHome.brand, slug = hotelHome.slug, about = hotelHome.about;
    var eventItems = [
        header.has_wedding == "true" && {
            title: locale == "id" ? "Pernikahan" : "Wedding",
            desctiption: locale == "id" ? "Rencanakan pernikahan di ".concat(header.name, ". Wujudkan impian pernikahan dambaanmu.") : "Plan a wedding at ".concat(header.is_parador ? "any Parador Hotel & Resort's property" : header.name, " and make your wedding dream come true."),
            target: "/".concat(slug, "/wedding"),
            thumbnail: hotelHome.wedding_thumbnail
        },
        header.has_social_events == "true" && {
            title: locale == "id" ? "Acara sosial" : "Social Events",
            desctiption: locale == "id" ? "Rencanakan acaramu. Biarkan kami melakukan sisanya" : "Plan your events ahead. Let us do the rest.",
            target: "/".concat(slug, "/meeting-events?filter=social"),
            thumbnail: hotelHome.events_thumbnail
        },
        header.has_meeting_events == "true" && {
            title: locale == "id" ? "Ruang Meeting" : "Meeting Room",
            desctiption: locale == "id" ? "Terletak strategis, ".concat(header.name, " memiliki ruang pertemuan & layanan perjamuan yang cocok untuk memenuhi kebutuhan Anda.") : "Strategically located, we offer comprehensive meeting rooms & banquet services that works best for you",
            target: "/".concat(slug, "/meeting-events?filter=venue"),
            thumbnail: hotelHome.meeting_thumbnail
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* default */.Z, {
                title: !(0,lodash.isEmpty)(hotelBrands.meta_title_id) && locale == "id" ? hotelBrands.meta_title_id : !(0,lodash.isEmpty)(hotelBrands.meta_title_en) ? hotelBrands.meta_title_en : "".concat(brand, " - ").concat(hotel_location, " | Parador Hotels & Resorts"),
                description: !(0,lodash.isEmpty)(hotelBrands.meta_desc_id) && locale == "id" ? hotelBrands.meta_desc_id : !(0,lodash.isEmpty)(hotelBrands.meta_desc_en) ? hotelBrands.meta_desc_en : home_subheadline,
                image: !(0,lodash.isEmpty)(hotelBrands.meta_thumb) ? hotelBrands.meta_thumb : hero ? hero.slider[0].url : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderV3/* default */.Z, {
                headerItem: header,
                isHomepage: true,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroV2/* default */.Z, {
                hasFormNow: true,
                heroItem: hero,
                height: "calc(100vh - ".concat(headerHeight1, "px)")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                position: "relative",
                bg: header.color_primary,
                h: "100%",
                top: 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBookNowV2/* default */.Z, {
                    hotelCode: header.hotel_code,
                    colorPrimary: header.color_primary
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHotelIntro, {
                hotelName: brand,
                hotelLoc: hotel_location,
                hotelDesc: home_subheadline,
                facilities: facilities,
                color: color_primary,
                slug: slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                w: "100%",
                px: mediaQuery/* safeMarginX */.Mp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                    opacity: 1,
                    my: 3,
                    borderWidth: 0.5,
                    py: 0.1,
                    borderColor: "blackAlpha.100",
                    bg: "blackAlpha.100"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionSpecialOffer/* default */.Z, {
                hotelName: brand,
                hotelLoc: hotel_location,
                color: color_primary,
                slug: slug,
                hotelCode: header.hotel_code,
                hotel: name
            }),
            header.has_dining && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDining/* default */.Z, {
                bg: color_primary,
                color: "white",
                params: {
                    hotel_name: name
                }
            }),
            (header.has_wedding == "true" || header.has_meeting_events == "true" || header.has_social_events == "true") && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionEvent/* default */.Z, {
                color: header.color_primary,
                items: (0,lodash.compact)(eventItems)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHotel/* default */.Z, {
                bg: color_primary,
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionGallery/* default */.Z, {
                slug: slug,
                color: color_primary,
                limit: 4,
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterHotel/* default */.Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: color_primary,
                color: color_secondary,
                logo: logo_light,
                hotelSlug: slug
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,6394,9996,9392,5299,4939,8078,3361,5316,9774,2888,179], function() { return __webpack_exec__(711); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);